import React, { useState, useEffect } from 'react';
import AddPerfil from './AddPerfil';
import { useAccesos } from '../contexts/AccesosContext';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

function Perfil() {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [perfiles, setPerfiles] = useState([]);
    const [editPerfil, setEditPerfil] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [perfilToDelete, setPerfilToDelete] = useState(null);

    useEffect(() => {
        fetchPerfiles();
    }, []);

    const fetchPerfiles = async () => {
        try {
            const response = await fetch(`${server}/sg_perfile`);
            const data = await response.json();
            setPerfiles(data.$values); // Asegúrate de que el objeto de datos tenga la propiedad $values
        } catch (error) {
            console.error('Error al cargar los perfiles:', error);
        }
    };

    const handleNewPerfil = () => {
        fetchPerfiles();
        setEditPerfil(null);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleOpenDialog = (perfil) => {
        setPerfilToDelete(perfil);
        setDeleteDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDeleteDialogOpen(false);
        setPerfilToDelete(null);
    };

    const handleDeletePerfil = async () => {
        if (perfilToDelete) {
            try {
                const response = await fetch(`${server}/sg_perfile/${perfilToDelete.id}`, { method: 'DELETE' });
                if (response.ok) {
                    setPerfiles(perfiles.filter(p => p.id !== perfilToDelete.id));
                    handleCloseDialog();
                    alert('Perfil eliminado con éxito');
                } else {
                    alert('Error al eliminar el perfil');
                }
            } catch (error) {
                console.error('Error al eliminar el perfil:', error);
                alert('Error al eliminar el perfil');
            }
        }
    };

    const filteredPerfiles = perfiles.filter(perfil => perfil.nombreperfil?.toLowerCase().includes(searchQuery.toLowerCase()));

    return (
        <>
            <div className="right_col" role="main">
                <div className="x_title"></div>
                <div className="x_content">
                    <AddPerfil onNewPerfil={handleNewPerfil} editPerfil={editPerfil} />
                    <h2>Perfiles Existentes</h2>
                    {/* <div className="row"> */}
                        {/* <div className="col-md-8 col-sm-6 offset-md-2"> */}
                            <TextField
                                fullWidth
                                variant="outlined"
                                label="Buscar perfil"
                                value={searchQuery}
                                onChange={handleSearchChange}
                                style={{ marginBottom: '20px' }}
                            />
                            <div className="table-responsive">
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <th>Nombre Perfil</th>
                                                <th>Estado</th>
                                                <th>Acciones</th>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {filteredPerfiles.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((perfil) => (
                                                <TableRow key={perfil.id}>
                                                    <TableCell>{perfil.nombreperfil}</TableCell>
                                                    <TableCell>{perfil.estado ? 'Activo' : 'Inactivo'}</TableCell>
                                                    <TableCell>
                                                        <Button onClick={() => setEditPerfil(perfil)} color="primary" disabled={!tienePermiso('Editar Perfil Seguridad')}>Editar</Button>
                                                        <Button onClick={() => handleOpenDialog(perfil)} color="secondary" disabled={!tienePermiso('Eliminar Perfil Seguridad')}>Eliminar</Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={filteredPerfiles.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </TableContainer>
                                <Dialog
                                    open={deleteDialogOpen}
                                    onClose={handleCloseDialog}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle>{"Confirmar eliminación"}</DialogTitle>
                                    <DialogContent>
                                        <DialogContentText>
                                            ¿Estás seguro de que deseas eliminar este perfil?
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleCloseDialog} color="primary">Cancelar</Button>
                                        <Button onClick={handleDeletePerfil} color="primary" autoFocus>Eliminar</Button>
                                    </DialogActions>
                                </Dialog>
                            </div>
                        {/* </div> */}
                    {/* </div> */}
                </div>
            </div>
        </>
    );
}

export default Perfil;
